import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    position: relative;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 2em;

    .socials-title {
        font-size: .8em;
        font-weight: 700;
        color: #3B3C43;
        margin-right: 1em;
    }

    .socials-icons {
        display: flex;
        justify-content: space-between;
        align-items: center;

        > * {
            margin-right: .5em;
            text-decoration: none;
            filter: invert() brightness(0);

            &:last-of-type {
                margin-right: 0;
            }

            &:hover {
                filter: initial;
            }
        }
    }

    @media all and (max-width: ${variables.mobileM}) {}
`;
